/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface BulkGetReactionsRequest {
    reactedToIds: Array<string>;
    type?: string;
}

/**
 * 
 */
export class ReactionsApi extends runtime.BaseAPI {

    /**
     * Gets reactions by reacted_to_id and type
     */
    async bulkGetReactionsRaw(requestParameters: BulkGetReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.reactedToIds === null || requestParameters.reactedToIds === undefined) {
            throw new runtime.RequiredError('reactedToIds','Required parameter requestParameters.reactedToIds was null or undefined when calling bulkGetReactions.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.reactedToIds) {
            queryParameters['reacted_to_ids'] = requestParameters.reactedToIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/reactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Gets reactions by reacted_to_id and type
     */
    async bulkGetReactions(requestParameters: BulkGetReactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkGetReactionsRaw(requestParameters, initOverrides);
    }

}
